const tr = {
  // Navigation
  'nav.dashboard': 'Kontrol Paneli',
  'nav.students': 'Öğrenciler',
  'nav.staff': 'Personel',
  'nav.generateChain': 'Zincir Oluştur',
  'nav.classes': 'Sınıflar',
  'nav.attendance': 'Yoklama',
  'nav.qrCheckIn': 'QR Giriş',
  'nav.qrCodes': 'QR Kodlar',
  'nav.classroom': 'Sınıf İçi',
  'nav.taskAssignment': 'Görev Atama',
  'nav.myTasks': 'Görevlerim',
  'nav.academicHub': 'Akademik Merkez',
  'nav.grades': 'Notlar',
  'nav.reportCards': 'Karne',
  'nav.fees': 'Ücretler',
  'nav.feeStructure': 'Ücret Yapısı',
  'nav.almanac': 'Takvim',
  'nav.announcements': 'Duyurular',
  'nav.myPortal': 'Portalım',
  'nav.teachers': 'Öğretmenler',
  'nav.documents': 'Belgeler',
  'nav.bin': 'Çöp Kutusu',
  'nav.expenses': 'Giderler',
  'nav.reports': 'Raporlar',
  'nav.logout': 'Çıkış',
  'nav.portal': 'Portal',

  // Common
  'common.save': 'Kaydet',
  'common.cancel': 'İptal',
  'common.delete': 'Sil',
  'common.edit': 'Düzenle',
  'common.add': 'Ekle',
  'common.search': 'Ara',
  'common.filter': 'Filtrele',
  'common.export': 'Dışa Aktar',
  'common.import': 'İçe Aktar',
  'common.download': 'İndir',
  'common.upload': 'Yükle',
  'common.loading': 'Yükleniyor...',
  'common.noData': 'Veri bulunamadı',
  'common.confirm': 'Onayla',
  'common.close': 'Kapat',
  'common.back': 'Geri',
  'common.next': 'İleri',
  'common.submit': 'Gönder',
  'common.update': 'Güncelle',
  'common.actions': 'İşlemler',
  'common.status': 'Durum',
  'common.type': 'Tür',
  'common.date': 'Tarih',
  'common.amount': 'Tutar',
  'common.description': 'Açıklama',
  'common.name': 'İsim',
  'common.email': 'E-posta',
  'common.phone': 'Telefon',
  'common.address': 'Adres',
  'common.notes': 'Notlar',
  'common.optional': 'İsteğe Bağlı',
  'common.required': 'Zorunlu',
  'common.all': 'Tümü',
  'common.none': 'Hiçbiri',
  'common.yes': 'Evet',
  'common.no': 'Hayır',
  'common.success': 'Başarılı',
  'common.error': 'Hata',
  'common.warning': 'Uyarı',
  'common.info': 'Bilgi',
  'common.total': 'Toplam',
  'common.average': 'Ortalama',
  'common.largest': 'En Büyük',
  'common.smallest': 'En Küçük',
  'common.count': 'Sayı',
  'common.percentage': 'Yüzde',
  'common.view': 'Görüntüle',
  'common.list': 'Liste',
  'common.analytics': 'Analiz',
  'common.print': 'Yazdır',
  'common.refresh': 'Yenile',
  'common.reset': 'Sıfırla',
  'common.clear': 'Temizle',
  'common.select': 'Seç',
  'common.selected': 'Seçili',
  'common.more': 'Daha Fazla',
  'common.less': 'Daha Az',
  'common.today': 'Bugün',
  'common.thisWeek': 'Bu Hafta',
  'common.thisMonth': 'Bu Ay',
  'common.thisYear': 'Bu Yıl',
  'common.allTime': 'Tüm Zamanlar',
  'common.newest': 'En yeni',
  'common.oldest': 'En eski',
  'common.newestFirst': 'En yeni ilk',
  'common.oldestFirst': 'En eski ilk',
  'common.sortBy': 'Sırala',
  'common.sortByDate': 'Tarihe Göre Sırala',
  'common.sortByAmount': 'Tutara Göre Sırala',
  'common.sortByCategory': 'Kategoriye Göre Sırala',
  'common.language': 'Dil',
  'common.english': 'İngilizce',
  'common.turkish': 'Türkçe',

  // Expenses
  'expenses.title': 'Giderler',
  'expenses.subtitle': 'Okul giderlerini takip et ve yönet',
  'expenses.addNew': 'Gider Ekle',
  'expenses.edit': 'Gider Düzenle',
  'expenses.total': 'Toplam Giderler',
  'expenses.average': 'Ortalama Gider',
  'expenses.categoriesUsed': 'Kullanılan Kategoriler',
  'expenses.largest': 'En Büyük Gider',
  'expenses.perTransaction': 'işlem başına',
  'expenses.differentCategories': 'farklı kategori',
  'expenses.transactions': 'işlem',
  'expenses.noExpenses': 'Gider bulunamadı',
  'expenses.adjustFilters': 'Filtrelerinizi ayarlamayı deneyin',
  'expenses.addFirst': 'İlk giderinizi kaydetmek için "Gider Ekle"ye tıklayın',
  'expenses.description': 'Açıklama',
  'expenses.descriptionPlaceholder': 'Örn., Mart ayı elektrik faturası',
  'expenses.amount': 'Tutar (TZS)',
  'expenses.amountPlaceholder': 'Örn., 500000',
  'expenses.category': 'Kategori',
  'expenses.paymentMethod': 'Ödeme Yöntemi',
  'expenses.expenseDate': 'Gider Tarihi',
  'expenses.vendor': 'Satıcı/Alacaklı',
  'expenses.vendorPlaceholder': 'Örn., TANESCO',
  'expenses.receiptImage': 'Fiş Görseli',
  'expenses.notes': 'Notlar',
  'expenses.notesPlaceholder': 'Ek detaylar...',
  'expenses.saveExpense': 'Gideri Kaydet',
  'expenses.updateExpense': 'Gideri Güncelle',
  'expenses.addNewTitle': 'Yeni Gider Ekle',
  'expenses.editTitle': 'Gider Düzenle',
  'expenses.descriptionRequired': 'Açıklama ve tutar zorunludur',
  'expenses.validAmount': 'Lütfen geçerli bir tutar girin',
  'expenses.addedSuccess': 'Gider başarıyla eklendi',
  'expenses.updatedSuccess': 'Gider başarıyla güncellendi',
  'expenses.deletedSuccess': 'Gider silindi',
  'expenses.savedLocally': 'Gider yerel olarak kaydedildi',
  'expenses.offlineMode': 'Gider yerel olarak kaydedildi (çevrimdışı mod)',
  'expenses.deletedLocally': 'Gider yerel olarak silindi',
  'expenses.confirmDelete': 'Bu gideri silmek istediğinize emin misiniz?',
  'expenses.exported': 'Dışa aktarıldı',
  'expenses.noExport': 'Dışa aktarılacak gider yok',
  'expenses.categoryBreakdown': 'Kategori Dağılımı',
  'expenses.monthlyTrends': 'Aylık Harcama Trendleri',
  'expenses.paymentMethods': 'Ödeme Yöntemleri',
  'expenses.noCategoryData': 'Henüz gider verisi yok',
  'expenses.noMonthlyData': 'Henüz aylık veri yok',
  'expenses.noPaymentData': 'Henüz ödeme verisi yok',
  'expenses.addExpense': 'Gider Ekle',
  'expenses.addNewExpense': 'Yeni Gider Ekle',
  'expenses.editExpense': 'Gider Düzenle',
  'expenses.noData': 'Henüz gider verisi yok',
  'expenses.allCategories': 'Tüm Kategoriler',

  // Dashboard
  'dashboard.title': 'Kontrol Paneli',
  'dashboard.welcome': 'Hoş Geldiniz',
  'dashboard.totalStudents': 'Toplam Öğrenci',
  'dashboard.totalStaff': 'Toplam Personel',
  'dashboard.totalClasses': 'Toplam Sınıf',
  'dashboard.recentActivity': 'Son Aktiviteler',
  'dashboard.quickActions': 'Hızlı İşlemler',

  // Students
  'students.title': 'Öğrenciler',
  'students.addStudent': 'Öğrenci Ekle',
  'students.editStudent': 'Öğrenci Düzenle',
  'students.firstName': 'Ad',
  'students.lastName': 'Soyad',
  'students.gender': 'Cinsiyet',
  'students.grade': 'Sınıf',
  'students.class': 'Şube',
  'students.parentName': 'Veli Adı',
  'students.parentPhone': 'Veli Telefon',
  'students.enrollmentDate': 'Kayıt Tarihi',
  'students.totalStudents': 'Toplam Öğrenci',
  'students.male': 'Erkek',
  'students.female': 'Kız',
  'students.searchPlaceholder': 'Öğrenci ara...',

  // Staff
  'staff.title': 'Personel',
  'staff.addStaff': 'Personel Ekle',
  'staff.editStaff': 'Personel Düzenle',
  'staff.firstName': 'Ad',
  'staff.lastName': 'Soyad',
  'staff.role': 'Rol',
  'staff.department': 'Bölüm',
  'staff.phone': 'Telefon',
  'staff.email': 'E-posta',
  'staff.salary': 'Maaş',
  'staff.totalStaff': 'Toplam Personel',
  'staff.searchPlaceholder': 'Personel ara...',

  // Classes
  'classes.title': 'Sınıflar',
  'classes.addClass': 'Sınıf Ekle',
  'classes.editClass': 'Sınıf Düzenle',
  'classes.className': 'Sınıf Adı',
  'classes.grade': 'Sınıf Seviyesi',
  'classes.teacher': 'Öğretmen',
  'classes.studentCount': 'Öğrenci Sayısı',
  'classes.totalClasses': 'Toplam Sınıf',
  'classes.searchPlaceholder': 'Sınıf ara...',

  // Attendance
  'attendance.title': 'Yoklama',
  'attendance.markAttendance': 'Yoklama Al',
  'attendance.date': 'Tarih',
  'attendance.class': 'Sınıf',
  'attendance.present': 'Mevcut',
  'attendance.absent': 'Yok',
  'attendance.late': 'Geç',
  'attendance.excused': 'Mazeretli',
  'attendance.rate': 'Yoklama Oranı',
  'attendance.totalPresent': 'Toplam Mevcut',
  'attendance.totalAbsent': 'Toplam Yok',
  'attendance.searchPlaceholder': 'Yoklama ara...',

  // Grades
  'grades.title': 'Notlar',
  'grades.addGrade': 'Not Ekle',
  'grades.editGrade': 'Not Düzenle',
  'grades.student': 'Öğrenci',
  'grades.subject': 'Ders',
  'grades.score': 'Puan',
  'grades.grade': 'Not',
  'grades.term': 'Dönem',
  'grades.exam': 'Sınav',
  'grades.assignment': 'Ödev',
  'grades.average': 'Ortalama',
  'grades.searchPlaceholder': 'Not ara...',

  // Fees
  'fees.title': 'Ücret Yönetimi',
  'fees.addFee': 'Ücret Ekle',
  'fees.editFee': 'Ücret Düzenle',
  'fees.student': 'Öğrenci',
  'fees.amount': 'Tutar',
  'fees.paid': 'Ödendi',
  'fees.pending': 'Bekliyor',
  'fees.overdue': 'Gecikmiş',
  'fees.totalCollected': 'Toplanan',
  'fees.totalPending': 'Bekleyen',
  'fees.dueDate': 'Son Tarih',
  'fees.paymentDate': 'Ödeme Tarihi',
  'fees.paymentMethod': 'Ödeme Yöntemi',
  'fees.receipt': 'Makbuz',
  'fees.searchPlaceholder': 'Ücret ara...',

  // Reports
  'reports.title': 'Raporlar',
  'reports.generate': 'Rapor Oluştur',
  'reports.type': 'Rapor Türü',
  'reports.dateRange': 'Tarih Aralığı',
  'reports.studentReport': 'Öğrenci Raporu',
  'reports.financialReport': 'Finansal Rapor',
  'reports.attendanceReport': 'Yoklama Raporu',
  'reports.gradeReport': 'Not Raporu',
  'reports.download': 'Raporu İndir',

  // Almanac
  'almanac.title': 'Takvim',
  'almanac.addEvent': 'Etkinlik Ekle',
  'almanac.editEvent': 'Etkinlik Düzenle',
  'almanac.eventTitle': 'Etkinlik Başlığı',
  'almanac.eventDate': 'Etkinlik Tarihi',
  'almanac.eventType': 'Etkinlik Türü',
  'almanac.description': 'Açıklama',
  'almanac.holiday': 'Tatil',
  'almanac.exam': 'Sınav',
  'almanac.meeting': 'Toplantı',
  'almanac.activity': 'Aktivite',
  'almanac.searchPlaceholder': 'Etkinlik ara...',

  // Documents
  'documents.title': 'Belgeler',
  'documents.upload': 'Belge Yükle',
  'documents.fileName': 'Dosya Adı',
  'documents.fileType': 'Dosya Türü',
  'documents.fileSize': 'Dosya Boyutu',
  'documents.uploadDate': 'Yükleme Tarihi',
  'documents.uploadedBy': 'Yükleyen',
  'documents.category': 'Kategori',
  'documents.searchPlaceholder': 'Belge ara...',

  // Bin
  'bin.title': 'Çöp Kutusu',
  'bin.restore': 'Geri Yükle',
  'bin.permanentDelete': 'Kalıcı Olarak Sil',
  'bin.empty': 'Çöp kutusu boş',
  'bin.restored': 'Öğe başarıyla geri yüklendi',
  'bin.deleted': 'Öğe kalıcı olarak silindi',
  'bin.searchPlaceholder': 'Silinen öğeleri ara...',

  // Tasks
  'tasks.title': 'Görev Atama',
  'tasks.addTask': 'Görev Ekle',
  'tasks.editTask': 'Görev Düzenle',
  'tasks.title': 'Görev Başlığı',
  'tasks.description': 'Açıklama',
  'tasks.assignedTo': 'Atanan Kişi',
  'tasks.assignedBy': 'Atayan Kişi',
  'tasks.dueDate': 'Bitiş Tarihi',
  'tasks.priority': 'Öncelik',
  'tasks.status': 'Durum',
  'tasks.high': 'Yüksek',
  'tasks.medium': 'Orta',
  'tasks.low': 'Düşük',
  'tasks.pending': 'Bekliyor',
  'tasks.inProgress': 'Devam Ediyor',
  'tasks.completed': 'Tamamlandı',
  'tasks.searchPlaceholder': 'Görev ara...',

  // My Tasks
  'myTasks.title': 'Görevlerim',
  'myTasks.noTasks': 'Size atanmış görev yok',
  'myTasks.markComplete': 'Tamamlandı Olarak İşaretle',
  'myTasks.searchPlaceholder': 'Görevlerinizi ara...',

  // Academic Hub
  'academicHub.title': 'Akademik Merkez',
  'academicHub.lessonPlans': 'Ders Planları',
  'academicHub.schemeOfWork': 'İş Programı',
  'academicHub.subjectEvaluation': 'Ders Değerlendirme',
  'academicHub.assessment': 'Değerlendirme Formları',
  'academicHub.searchPlaceholder': 'Akademik kaynak ara...',

  // QR Attendance
  'qrAttendance.title': 'QR Giriş',
  'qrAttendance.scan': 'QR Kod Tara',
  'qrAttendance.generate': 'QR Kod Oluştur',
  'qrAttendance.studentName': 'Öğrenci Adı',
  'qrAttendance.time': 'Giriş Saati',
  'qrAttendance.date': 'Tarih',
  'qrAttendance.status': 'Durum',
  'qrAttendance.verified': 'Doğrulandı',
  'qrAttendance.pending': 'Bekliyor',

  // QR Management
  'qrManagement.title': 'QR Kodlar',
  'qrManagement.generate': 'QR Kod Oluştur',
  'qrManagement.print': 'QR Kod Yazdır',
  'qrManagement.student': 'Öğrenci',
  'qrManagement.class': 'Sınıf',
  'qrManagement.searchPlaceholder': 'QR kod ara...',

  // Fee Structure
  'feeStructure.title': 'Ücret Yapısı',
  'feeStructure.addFee': 'Ücret Kalemi Ekle',
  'feeStructure.editFee': 'Ücret Kalemi Düzenle',
  'feeStructure.feeName': 'Ücret Adı',
  'feeStructure.amount': 'Tutar',
  'feeStructure.grade': 'Sınıf',
  'feeStructure.term': 'Dönem',
  'feeStructure.dueDate': 'Son Tarih',
  'feeStructure.searchPlaceholder': 'Ücret yapısı ara...',

  // Announcements
  'announcements.title': 'Duyurular',
  'announcements.add': 'Duyuru Ekle',
  'announcements.edit': 'Duyuru Düzenle',
  'announcements.title': 'Başlık',
  'announcements.content': 'İçerik',
  'announcements.audience': 'Hedef Kitle',
  'announcements.everyone': 'Herkes',
  'announcements.staffOnly': 'Sadece Personel',
  'announcements.studentsOnly': 'Sadece Öğrenciler',
  'announcements.date': 'Tarih',
  'announcements.searchPlaceholder': 'Duyuru ara...',

  // Classroom
  'classroom.title': 'Sınıf İçi',
  'classroom.addAssignment': 'Ödev Ekle',
  'classroom.submit': 'Çalışmayı Gönder',
  'classroom.grade': 'Not',
  'classroom.feedback': 'Geri Bildirim',
  'classroom.dueDate': 'Son Teslim Tarihi',
  'classroom.searchPlaceholder': 'Sınıf içi ara...',

  // Teachers
  'teachers.title': 'Öğretmenler',
  'teachers.totalTeachers': 'Toplam Öğretmen',
  'teachers.subject': 'Ders',
  'teachers.qualification': 'Nitelik',
  'teachers.searchPlaceholder': 'Öğretmen ara...',

  // Student Portal
  'studentPortal.title': 'Portalım',
  'studentPortal.myGrades': 'Notlarım',
  'studentPortal.myAttendance': 'Yoklamam',
  'studentPortal.myFees': 'Ücretlerim',
  'studentPortal.myTasks': 'Görevlerim',
  'studentPortal.announcements': 'Duyurular',
  'studentPortal.profile': 'Profilim',

  // Report Cards
  'reportCards.title': 'Karne',
  'reportCards.generate': 'Karne Oluştur',
  'reportCards.student': 'Öğrenci',
  'reportCards.grade': 'Sınıf',
  'reportCards.term': 'Dönem',
  'reportCards.subject': 'Ders',
  'reportCards.score': 'Puan',
  'reportCards.average': 'Ortalama',
  'reportCards.rank': 'Sıra',
  'reportCards.searchPlaceholder': 'Karnelerde ara...',

  // Chain Landing
  'chainLanding.title': 'Okul Portalı',
  'chainLanding.login': 'Giriş',
  'chainLanding.chainInfo': 'Zincir Bilgisi',

  // Login
  'login.title': 'Giriş',
  'login.accessCode': 'Erişim Kodu',
  'login.password': 'Şifre',
  'login.portal': 'Portal',
  'login.chain': 'Zincir',
  'login.submit': 'Giriş Yap',
  'login.error': 'Geçersiz kimlik bilgileri',
  'login.loggingIn': 'Giriş yapılıyor...',

  // Home
  'home.title': 'IHEZA Okul Yönetim Sistemi',
  'home.subtitle': 'Kapsamlı okul yönetim çözümü',
  'home.getStarted': 'Başlayın',
  'home.learnMore': 'Daha Fazla Bilgi',

  // Generate Chain
  'generateChain.title': 'Zincir Oluştur',
  'generateChain.chainName': 'Zincir Adı',
  'generateChain.chainCode': 'Zincir Kodu',
  'generateChain.generate': 'Oluştur',
  'generateChain.success': 'Zincir başarıyla oluşturuldu',
  'generateChain.error': 'Zincir oluşturulamadı',

  // Subject Evaluation
  'subjectEvaluation.title': 'Ders Değerlendirme',
  'subjectEvaluation.subject': 'Ders',
  'subjectEvaluation.teacher': 'Öğretmen',
  'subjectEvaluation.grade': 'Sınıf',
  'subjectEvaluation.term': 'Dönem',
  'subjectEvaluation.score': 'Puan',
  'subjectEvaluation.comments': 'Yorumlar',
  'subjectEvaluation.searchPlaceholder': 'Değerlendirme ara...',

  // Scheme of Work
  'schemeOfWork.title': 'İş Programı',
  'schemeOfWork.subject': 'Ders',
  'schemeOfWork.term': 'Dönem',
  'schemeOfWork.week': 'Hafta',
  'schemeOfWork.topic': 'Konu',
  'schemeOfWork.objectives': 'Hedefler',
  'schemeOfWork.searchPlaceholder': 'İş programı ara...',

  // Lesson Plan
  'lessonPlan.title': 'Ders Planı',
  'lessonPlan.subject': 'Ders',
  'lessonPlan.topic': 'Konu',
  'lessonPlan.date': 'Tarih',
  'lessonPlan.duration': 'Süre',
  'lessonPlan.objectives': 'Hedefler',
  'lessonPlan.materials': 'Materyaller',
  'lessonPlan.activities': 'Aktiviteler',
  'lessonPlan.assessment': 'Değerlendirme',
  'lessonPlan.searchPlaceholder': 'Ders planı ara...',

  // Assessment Form
  'assessment.title': 'Değerlendirme Formları',
  'assessment.student': 'Öğrenci',
  'assessment.subject': 'Ders',
  'assessment.type': 'Değerlendirme Türü',
  'assessment.score': 'Puan',
  'assessment.total': 'Toplam Puan',
  'assessment.date': 'Tarih',
  'assessment.comments': 'Yorumlar',
  'assessment.searchPlaceholder': 'Değerlendirme ara...',

  // Chain Toggle
  'chainToggle.selectChain': 'Zincir Seç',
  'chainToggle.allChains': 'Tüm Zincirler',
};

export default tr;
